import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Some routes are prerendered at build time (see scripts/prerender.mjs) and served with real
// markup already in #root. Deliberately NOT hydrating that markup: every route in this app is
// React.lazy() + Suspense-wrapped, and plain hydrateRoot (no streaming-SSR boundary markers,
// which a page.content() snapshot can't produce) mismatches against a Suspense boundary that
// briefly wants to show its loading fallback before the lazy chunk resolves -- confirmed via
// React error #418 breaking interactivity on /tools/debt-payoff in testing. A plain render()
// just replaces the snapshot outright, identical to this app's behavior before prerendering
// existed -- real users notice nothing; non-JS crawlers, which never run this at all, still
// get the full static snapshot either way.
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
